import { LISBON_BUILDING_ID, PORTO_BUILDING_ID } from '../../constants/buildings';

export class BuildingUtils {
  static isPorto = (buildingId: string) => buildingId === PORTO_BUILDING_ID;
  static isLisbon = (buildingId: string) => buildingId === LISBON_BUILDING_ID;
}
